import { Pipe, PipeTransform } from '@angular/core';

// This is webpack's publicPath and Angular's deployUrl
declare let __webpack_public_path__: string;

function joinPaths(paths: string[]): string {
	return paths
		.map((p) => p.replace(/\/$/, ''))
		.filter((p) => p !== '')
		.join('/')
		.replace(/\/(\.\/)+/, '/');
}

/**
 * ResolveAssetPipe is currently included in our Backpack module because we used to render
 * icons using `src` tags on an `img` element. Now, we use SVGs inline, so this pipe could
 * be moved outside of our design system.
 */
@Pipe({
	name: 'resolveAsset',
	standalone: true,
})
export class ResolveAssetPipe implements PipeTransform {
	transform<T = unknown>(value: T): string | T {
		if (typeof value !== 'string') {
			return value;
		}

		if (value.startsWith('../')) {
			throw new Error(`Asset path must not use parent directory path segments: ${value}`);
		}

		if (value.startsWith('http://') || value.startsWith('https://')) {
			return value;
		}

		return joinPaths([__webpack_public_path__, value]);
	}
}
